export const USERS_REQUESTED = 'users/USERS_REQUESTED'
export const USERS_SUCCEED = 'users/USERS_SUCCEED'
export const USERS_FAIL = 'users/USERS_FAIL'
export const UPDATE_USER = 'users/UPDATE_USER'



// WEBPACK FOOTER //
// ./src/redux/users/actionTypes.js